import { DictionaryEvidence, TableCells, TableColumn } from '@eas/common-web';
import { Department, FormTemplate, WorkOrderType } from '@models';

export function useColumns(): TableColumn<FormTemplate>[] {
  const { columnName, columnCreated, columnUpdated } =
    DictionaryEvidence.useDictionaryColumns<FormTemplate>();

  return [
    {
      datakey: 'muzaFormId',
      name: 'Muza Form ID',
      width: 120,
      CellComponent: TableCells.TextCell,
      sortable: false,
      filterable: false,
    },
    columnName,
    {
      datakey: 'workOrderTypes',
      name: 'Druhy pracovních príkazov',
      width: 250,
      CellComponent: function WorkOrderTypeCell(props) {
        return TableCells.TextCell({
          ...props,
          value: props.value
            .map((workOrderType: WorkOrderType) => workOrderType.name)
            .join(', '),
        });
      },
      sortable: false,
      filterable: false,
    },
    {
      datakey: 'departments',
      name: 'Pracoviská',
      width: 200,
      CellComponent: function DepartmentCell(props) {
        return TableCells.TextCell({
          ...props,
          value: props.value
            .map((department: Department) => department?.name)
            .join(', '),
        });
      },
      sortable: false,
      filterable: false,
    },
    columnCreated,
    columnUpdated,
  ];
}
